import { useMutation } from '@tanstack/react-query';
import { login } from './user.thunks';

function useLogin() {
  const { mutate, isLoading } = useMutation({
    mutationKey: ['login'],
    mutationFn: (data) => login(data),
  });
  return {
    mutate,
    isPending: isLoading,
  };
}

export default useLogin;
